import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useI18n } from '@affiliate-cabinet/i18n'
import { Button, ButtonVariantEnum, Flex } from '@affstore-ds/uikit'

import { ErrorPage } from '../../shared/components/ErrorPage'
import { errorPageTranslationKeys } from '../../shared/translations/errorPage.translationKeys'

export const NotFound = () => {
  const { i18n } = useI18n()
  const navigate = useNavigate()

  return (
    <ErrorPage
      title={i18n.t(errorPageTranslationKeys.errorPage404Title)}
      codeError={404}
      description={<>{i18n.t(errorPageTranslationKeys.errorPage404Description)}</>}
    >
      <Flex align="flex-start" direction={{ md: 'row-reverse', xs: 'column' }} gap={16} justify="stretch" mt={24} wrap="nowrap">
        <Button onClick={() => navigate('/')}>{i18n.t(errorPageTranslationKeys.errorPageButtonGoToHomePage)}</Button>
        <Button
          onClick={() => {
            /* Navigate to previous page */
            navigate(-1)
          }}
          elementVariant={ButtonVariantEnum.SecondaryMain}
          w={{ md: 'auto', xs: '100%' }}
        >
          {i18n.t(errorPageTranslationKeys.errorPageButtonPreviousPage)}
        </Button>
      </Flex>
    </ErrorPage>
  )
}
